import React from "react";

const Footer = function()
{
    return(
        <div>

                <div className="footer">
                    <a className="footerAnchors" rel="noreferrer" href="https://www.facebook.com/ekonkarGames/" target={'_blank'} > Facebook </a>
                    <a className="footerAnchors" rel="noreferrer" href="https://www.youtube.com/channel/UC8VdmfeDdhMkqdAGq72Np8A" target={'_blank'} > Youtube </a>
                    <a className="footerAnchors" rel="noreferrer" href="https://ekonkargames.web.app/privacypolicy.html" target={'_blank'} > Policy</a>
                    <br></br>
                    <br></br>           
                </div>

                <div>
                    <p className="copyright">&copy;  2022-23 Ekonkar Games
                        all rights reserved
                    </p>
                </div>
        </div>
    );
}
export default Footer;